import script from "./SolutionsView.vue?vue&type=script&setup=true&lang=js"
export * from "./SolutionsView.vue?vue&type=script&setup=true&lang=js"

import "./SolutionsView.vue?vue&type=style&index=0&id=4aed372f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4aed372f"]])

export default __exports__